
import React, { useState,useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { accountInfo } from '../../../plugins/adminRecoil';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import axios from '../../../plugins/axios';
import Toast from "../../../plugins/useToast";

import Icon from '@mdi/react';
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import {ReactComponent as IconArrowUp} from '../../../assets/icons/ic-arrow-up.svg'
import {ReactComponent as IconArrowDown} from '../../../assets/icons/ic-arrow-down.svg'
import {ReactComponent as IconCheck} from '../../../assets/icons/ic-check_blue.svg';

const AccountForm = ({ mode = 'add', handSelectMenu, handleSetConfirm }) => {
    const { t } = useTranslation()
    const [globalAccount, setGlobalAccount] = useRecoilState(accountInfo);            
    const [radioStatus, setRadioStatus] = useState('ACTIVE'); //Edit 모드에서만 사용.
    const [AccountInfo, setAccountInfo] = useState({
        Name : '',
        ID : '',
        Pass : '',
        PassConfirm : '',
        Phone : '',
        Type : 'USER',  
        Department : {value : null, label : t('admin.Account.form.Unassigned')}, // 초기값은 Unassigned로 설정
        Note : '',
    });    
    const [isSecure, setIsSecure] = useState({
        Pass: true,
        PassConfirm: true
    });
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [departmentList, setDepartmentList] = useState([]);
    const [saveValid, setSaveValid] = useState({
        name: false,
        id: false,
        phone: false,
        type: false,
        pass : false 
    });
    const isAllValid = Object.values(saveValid).every(Boolean);

    // ✅ Department 선택을 위한 리스트 가져오기 함수
    const getDepartment = async () => {
        try{
            const res = await axios.get('/departments'); // API 경로는 실제 API에 맞게 수정
            if(res.code != 200) throw res;            
            
            const department = [];
            department.push({value : null, label : t('admin.Account.form.Unassigned')});

            const departments = res.data.content.map(department => ({
                value: department.id,
                label: department.name
            }));
            department.push(...departments);

            setDepartmentList(department);
        }
        catch(err) {
            console.warn(err);
        }
    }    

    // ✅ Account Save 버튼 이벤트
    const handleAddAccount = async () => {
        try{
            const payload = {
                name: AccountInfo.Name,
                phoneNumber: AccountInfo.Phone,
                departmentId: AccountInfo.Department.value,
                loginId: AccountInfo.ID,
                note: AccountInfo.Note,
                role: AccountInfo.Type,
                status: "ACTIVE",
                password: AccountInfo.Pass,
            }

            const res = await axios.post('/user', payload); // API 경로는 실제 API에 맞게 수정
            if(res.code != 200) throw res;

            Toast({ isSuccess: true, msg: t(`admin.Account.form.saveSuccess`) });
            handSelectMenu('Account'); // Account 목록으로 이동
        }
        catch(err){
            if(err.code == 1001){
                Toast({ isSuccess: false, msg: err.message });
            }
            console.warn(err);
        }
    }

    // ✅ Account Edit Save 버튼 이벤트
    const handleEditAccount = async () => {
        try{
            const payload = {                
                name: AccountInfo.Name,
                phoneNumber: AccountInfo.Phone,
                departmentId: AccountInfo.Department.value,
                loginId: AccountInfo.ID,
                note: AccountInfo.Note,
                role: AccountInfo.Type,
                status: AccountInfo.status,
            }

            const res = await axios.put(`/user/${globalAccount.id}`, payload); // API 경로는 실제 API에 맞게 수정
            if(res.code != 200) throw res;

            Toast({ isSuccess: true, msg: t(`admin.Account.form.saveSuccess`) });
            handSelectMenu('Account'); // Account 목록으로 이동
        } catch(err) {
            if(err.code == 1001){
                Toast({ isSuccess: false, msg: err.message });
            }
            console.warn(err);
        }
    }    

    // ✅ Account Delete 버튼 이벤트
    const handleDeleteAccount = async () => {
        try{
            const res = await axios.delete(`/user/${globalAccount.id}`); // API 경로는 실제 API에 맞게 수정
            if(res.code != 200) throw res;

            Toast({ isSuccess: true, msg: t(`admin.Account.form.deleteSuccess`) });
            handSelectMenu('Account'); // Account 목록으로 이동
        }
        catch(err){
            console.log(err);
        }
    }

    useEffect(() => {
        getDepartment();
        if(mode == 'edit'){
            console.log('globalAccount : ',globalAccount);
            setAccountInfo({
                Name : globalAccount.name,
                ID : globalAccount.loginId,
                Pass : '',
                PassConfirm : '',
                Phone : globalAccount.phoneNumber,
                Type : globalAccount.role,
                Department : {value : globalAccount.departmentId, label : globalAccount.departmentName ? globalAccount.departmentName : t('admin.Account.form.Unassigned')},
                Note : globalAccount.note,
                status: globalAccount.status,
                CreateAt : globalAccount.createdAt,
                LastLogin : globalAccount.lastLogin ? globalAccount.lastLogin : null,
            });            
        }
        
        const handleClickOutside = (event) => {
            if (!event.target.closest('.select-dropdown')) {
                setIsDropdownOpen(null);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    // ✅ Save 버튼 Disabled 여부 
    useEffect(() => {
        setSaveValid({
            name: AccountInfo.Name !== '',
            id: AccountInfo.ID !== '',
            phone: AccountInfo.Phone !== '',
            type: AccountInfo.Type !== '',
            pass : mode === 'add' ? (AccountInfo.Pass !== '' && AccountInfo.PassConfirm !== '' && AccountInfo.Pass === AccountInfo.PassConfirm) : true,
        });
    }, [AccountInfo.ID, AccountInfo.Name, AccountInfo.Phone, AccountInfo.Type, AccountInfo.Pass, AccountInfo.PassConfirm]);

    return (
        <div className='relative'>
            <div className='flex justify-between mb-[24px]'>
                <h1 className="admin-title">{mode == 'add' ? t('admin.Account.form.addAccount') : t('admin.Account.form.editAccount')}</h1>
                {
                    mode == 'add' ? (
                        <div className='flex gap-[11px]'>
                            <div className="admin-normal-btn w-[88px] h-[32px]" onClick={() => handSelectMenu('Account')}>
                                <span className="btn-content">{t('admin.list')}</span>
                            </div>
                            <div className="w-[1px] h-[24px] bg-[#0D0D0F]"></div>
                            <div className={`admin-normal-btn ${!isAllValid ? 'disabled' : ''} add w-[120px] h-[32px]`} onClick={isAllValid ? () => handleAddAccount() : undefined}>
                                <span className="btn-content">{t('admin.save')}</span>
                            </div>
                        </div>
                    ) : (
                        <div className='flex gap-[11px]'>
                            <div className="admin-normal-btn w-[88px] h-[32px]" onClick={() => handSelectMenu('Account')}>
                                <span className="btn-content">{t('admin.list')}</span>
                            </div>
                            <div className="w-[1px] h-[24px] bg-[#0D0D0F]" ></div>
                            <div className="admin-normal-btn w-[88px] h-[32px]" onClick={() => handleSetConfirm('account','delete', true,handleDeleteAccount,null,'','',t(`admin.Account.confirm.delete`))}>
                                <span className="btn-content">{t('admin.delete')}</span>
                            </div>
                            <div className={`admin-normal-btn ${!isAllValid ? 'disabled' : ''} add w-[120px] h-[32px]`} onClick={isAllValid ? () => handleEditAccount() : undefined}>
                                <span className="btn-content">{t('admin.save')}</span>
                            </div>
                        </div>
                    )
                }
            </div>
            <div className='flex flex-col gap-[12px]'>
                <div className='flex justify-start items-center gap-[20px]'>
                    <div className='w-[180px]'>
                        <span className='text-white'>{t('admin.Account.form.Name')}</span><span className='text-[#FF2B5E]'>＊</span>
                    </div>
                    <div className='w-[640px]'>
                        <input
                            type="text"
                            value={AccountInfo.Name || ''}
                            onChange={(e) => {                               
                                const value = e.target.value.replace(/[^\p{Script=Hangul}a-zA-Z0-9\s]/gu, ''); // 영문, 한글(완성+조합), 공백 허용
                                console.log('value : ',value);
                                setAccountInfo({ ...AccountInfo, Name: value });
                            }}
                            placeholder={t('admin.Account.form.NamePlaceholder')}
                            className="admin-input w-full px-[12px] py-[7px]"    
                            autoComplete="one-time-code"
                            maxLength={30}                        
                        />
                    </div>
                </div>
                <div className='flex justify-start items-center gap-[20px]'>
                    <div className='w-[180px]'>
                        <span className='text-white'>{t('admin.Account.form.ID')}</span><span className='text-[#FF2B5E]'>＊</span>
                    </div>
                    <div className='w-[640px]'>
                        <input
                            type="text"
                            value={AccountInfo.ID || ''}
                            onChange={(e) => {
                                // 이메일 형식에 허용되는 문자만 입력 가능
                                const value = e.target.value.replace(/[^a-zA-Z0-9@._-]/g, '');
                                setAccountInfo({ ...AccountInfo, ID: value });
                            }}
                            onBlur={                                
                                (e) => {
                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;    
                                    if(e.target.value && !emailRegex.test(e.target.value)){
                                        Toast({ isSuccess: false, msg: t('admin.Account.form.IDValid') });
                                        setAccountInfo({ ...AccountInfo, ID: '' });
                                    }
                                }
                            }
                            placeholder={t('admin.Account.form.IDPlaceholder')}
                            className="admin-input w-full px-[12px] py-[7px]"
                            autoComplete="one-time-code"
                            maxLength={50}
                        />
                    </div>
                </div>
                {
                    mode === 'add' && (
                        <>
                            <div className='flex justify-start items-center gap-[20px]'>
                                <div className='w-[180px]'>
                                    <span className='text-white'>{t('admin.Account.form.Password')}</span><span className='text-[#FF2B5E]'>＊</span>
                                </div>
                                <div className='relative w-[640px]'>
                                    <input
                                        type={isSecure.Pass ? "password" : "text"}
                                        value={AccountInfo.Pass || ''}
                                        onChange={(e) => setAccountInfo({ ...AccountInfo, Pass: e.target.value })}
                                        placeholder={t('admin.Account.form.PassPlaceholder')}
                                        className="admin-input w-full px-[12px] py-[7px]"
                                        autoComplete="one-time-code"
                                        maxLength={40}
                                    />
                                    <button type="button" onClick={() => setIsSecure({...isSecure, Pass: !isSecure.Pass})} className="absolute right-2 top-[5px]">
                                        <Icon path={isSecure.Pass ? mdiEyeOffOutline : mdiEyeOutline} size={1} color="#FFFFFF4D" />
                                    </button>
                                </div>
                            </div>
                            <div className='flex justify-start items-center gap-[20px]'>
                                <div className='w-[180px]'>
                                    <span className='text-white'>{t('admin.Account.form.PasswordConfirm')}</span><span className='text-[#FF2B5E]'>＊</span>
                                </div>
                                <div className='relative w-[640px]'>
                                    <input
                                        type={isSecure.PassConfirm ? "password" : "text"}
                                        value={AccountInfo.PassConfirm || ''}
                                        onChange={(e) => setAccountInfo({ ...AccountInfo, PassConfirm: e.target.value })}
                                        placeholder={t('admin.Account.form.PassConfirmPlaceholder')}
                                        className="admin-input w-full px-[12px] py-[7px]"
                                        autoComplete="one-time-code"
                                        maxLength={40}
                                    />
                                    <button type="button" onClick={() => setIsSecure({...isSecure, PassConfirm: !isSecure.PassConfirm})} className="absolute right-2 top-[5px]">
                                        <Icon path={isSecure.PassConfirm ? mdiEyeOffOutline : mdiEyeOutline} size={1} color="#FFFFFF4D" />
                                    </button>
                                </div>
                            </div>
                        </>
                    )
                }
                
                <div className='flex justify-start items-center gap-[20px]'>
                    <div className='w-[180px]'>
                        <span className='text-white'>{t('admin.Account.form.Phone')}</span><span className='text-[#FF2B5E]'>＊</span>
                    </div>
                    <div className='flex justify-start items-center gap-[8px] w-[640px]'>
                        <input
                            type="text"
                            value={AccountInfo.Phone || ''}
                            onChange={(e) => {
                                const value = e.target.value.replace(/[^0-9+-]/g, ''); // 숫자, +, - 만 허용
                                setAccountInfo({ ...AccountInfo, Phone: value });
                            }}
                            className="admin-input w-full px-[12px] py-[7px]"
                            autoComplete="one-time-code"
                            maxLength={20}
                        />                                           
                    </div>
                </div>
                <div className='flex justify-start items-center gap-[20px]'>
                    <div className='w-[180px]'>
                        <span className='text-white'>{t('admin.Account.form.Type')}</span><span className='text-[#FF2B5E]'>＊</span>
                    </div>
                    <div className="flex items-center">
                        <label className="custom-radio">
                            <input
                                type="radio"
                                checked={AccountInfo.Type == 'USER'}
                                onChange={() => setAccountInfo({ ...AccountInfo, Type: 'USER' })}
                            />
                            <span className="font-light">{t('admin.Account.form.TypeUser')}</span>
                        </label>
                        <label className="custom-radio">
                            <input
                                type="radio"
                                checked={AccountInfo.Type == 'ADMIN'}
                                onChange={() => setAccountInfo({ ...AccountInfo, Type: 'ADMIN' })}
                            />
                            <span className="font-light">{t('admin.Account.form.TypeAdmin')}</span>
                        </label>
                    </div>
                </div>
                <div className='flex justify-start items-center gap-[20px]'>
                    <div className='w-[180px]'>
                        <span className='text-white'>{t('admin.Account.form.Department')}</span>
                    </div> 
                    <div className="relative w-[640px] select-dropdown">
                        <div className="border border-[#0D0D0F] bg-gradient-to-b from-[#5B5C60] to-[#303237] shadow-[inset_0_-2px_1px_0_rgba(255,255,255,0.10),inset_0_2px_0_0_rgba(255,255,255,0.12)] text-[#DEDEDE] w-full h-[32px] px-[8px] rounded-[6px] cursor-pointer flex items-center justify-between"
                            onClick={(e) => { e.stopPropagation(); setIsDropdownOpen(!isDropdownOpen);}}>
                            <div className="w-full whitespace-nowrap">{AccountInfo.Department.label}</div>
                            <div className="pointer-events-none">
                                {isDropdownOpen ? <IconArrowUp /> : <IconArrowDown />}
                            </div>
                        </div>
                        {isDropdownOpen && (
                            <div className="absolute top-[35px] bg-[#1F1F1F] w-full py-[8px] rounded-[6px] border border-[#5E5E5E] shadow-[0px_12px_12px_0px_rgba(0,0,0,0.4)] z-20">
                                {
                                    departmentList.map((department, index) => {
                                        return (
                                            <div key={index} className={`bg-[#1F1F1F] cursor-pointer h-[32px] flex items-center justify-between px-[8px] hover:bg-[#2F2F2F] 
                                                ${AccountInfo.Department.value === department.value ? "text-[#3182F7]" : "text-white"}`}
                                                onClick={(e) => { e.stopPropagation(); setAccountInfo({ ...AccountInfo, Department: department }); setIsDropdownOpen(false); }}>
                                                {department.label}
                                                {AccountInfo.Department.value === department.value && (
                                                    <IconCheck className="w-4 h-4 ml-2" />
                                                )}
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )}
                    </div>
                </div>
                <div className='flex justify-start items-center gap-[20px]'>
                    <div className='w-[180px]'>
                        <span className='text-white'>{t('admin.Account.form.Note')}</span>
                    </div>
                    <div className='w-[640px]'>
                        <textarea 
                            className='w-full h-[120px] p-[7px_12px] rounded-[6px] bg-[#0D0D0F] shadow-[inset_0_-1px_0_0_#5A5C63,inset_0_2px_1px_0_rgba(0,0,0,0.50)] text-white border-none outline-none resize-none focus:outline-none focus:border-none'
                            value={AccountInfo.Note || ''}
                            onChange={(e) => setAccountInfo({ ...AccountInfo, Note: e.target.value })}
                        >
                        </textarea>
                    </div>
                </div>
                {
                    mode === 'edit' && (
                        <>
                            <div className='flex justify-start items-center gap-[20px]'>
                                <div className='w-[180px]'>
                                    <span className='text-white'>{t('admin.Account.form.DateCreated')}</span>
                                </div>
                                <div className='w-[640px]'>
                                    {/* <p className='text-white'>{moment().format('YYYY-MM-DD hh:mm:ss')}</p> */}
                                    <p className='text-white'>{AccountInfo.CreateAt ? moment(AccountInfo.CreateAt).format('YYYY-MM-DD hh:mm:ss') : '-'}</p>
                                </div>
                            </div>
                            <div className='flex justify-start items-center gap-[20px]'>
                                <div className='w-[180px]'><span className='text-white'>{t('admin.Account.form.LastLogin')}</span></div>
                                <div className='w-[640px]'>
                                    <p className='text-white'>{AccountInfo.LastLogin ? moment(AccountInfo.LastLogin).format('YYYY-MM-DD hh:mm:ss') : '-'}</p>
                                </div>
                            </div>
                            <div className='flex justify-start items-center gap-[20px]'>
                                <div className='w-[180px]'>
                                    <span className='text-white'>{t('admin.Account.form.Status')}</span>
                                </div>
                                <div className="flex">
                                    <label className="custom-radio">
                                        <input
                                            type="radio"
                                            checked={AccountInfo.status === 'ACTIVE'}
                                            onChange={() => setAccountInfo({ ...AccountInfo, status: 'ACTIVE' })}
                                        />
                                        <span className="font-light">{t('admin.Account.form.StatusActive')}</span>
                                    </label>
                                    <label className="custom-radio">
                                        <input
                                            type="radio"
                                            checked={AccountInfo.status === 'INACTIVE'}
                                            onChange={() => setAccountInfo({ ...AccountInfo, status: 'INACTIVE' })}
                                        />
                                        <span className="font-light">{t('admin.Account.form.StatusInActive')}</span>
                                    </label>
                                </div>
                            </div>
                        </>
                    )
                }
                
            </div>
        </div>
    );
};

export default AccountForm;